import * as ExcelJS from 'exceljs';
import { saveAs } from 'file-saver';
import { startCase } from 'lodash';
import { DataExporterFactory } from './data-exporter.factory';

export class XlsDataExporter implements DataExporterFactory {
  exportJson(filename: string, data: object[]) {
    const workbook = new ExcelJS.Workbook();
    const worksheet = workbook.addWorksheet();

    worksheet.columns = Object.keys(data[0] || {}).map((key) => ({
      key,
      header: startCase(key),
    }));

    worksheet.addRows(data);

    workbook.xlsx.writeBuffer().then((buffer) => {
      saveAs(new Blob([buffer]), `${filename}.xls`);
    });
  }
}
